import axios from "@/libs/api.request.js";
import { getEnv } from "./heziShare";

// ${getEnv()}
// 游戏预约-详情
export const activeDetail = (id) => axios.request({ url: `${getEnv()}/wx-box-active/active/game-appointment/config-details/${id}`, method: "get" });
// 游戏预约
export const subscribeGame = (data) => axios.request({ url: `${getEnv()}/wx-box-active/active/game-appointment/order`, data});
// 领取礼包
export const rewardGift = (data) => axios.request({ url: `${getEnv()}/wx-box-active/active/game-appointment/gift-receive`, data});

// 活动公告-列表
export const getNoticeList = (params) => axios.request({ url: `${getEnv()}/wx-box-active/active/game-appointment/notices-list`, method: "get", params });
// 活动公告-详情
export const getNoticeDetail = (id) => axios.request({ url: `${getEnv()}/wx-box-active/active/game-appointment/notices/${id}`, method: "get" });
